// Lookups of global reference data (no tenant records) that shared link sessions may request directly, under
// /api/ui/shared/lookups. Used for shared links created before lookups were saved on the link.
const SHARED_PUBLIC_LOOKUP_PATHS = [
  '/countries',
  '/regions',
  '/cities',
  '/cityNames',
  '/protocols',
  '/asns/public',
  '/cdns',
  '/ott/provider',
  '/ott/service',
  '/ott/type'
];

module.exports = {
  SHARED_PUBLIC_LOOKUP_PATHS
};
